import type { AuthResponse, User } from '@conversia/shared-types';
import { useAuthStore } from '@/store/auth.store';
import { apiFetch } from '@/api/client';

/**
 * «VER COMO» en el panel: la administración entra a otra cuenta sin cerrar la suya.
 *
 * La sesión de la administración se guarda aparte mientras tanto; la de la otra cuenta es un
 * token de una hora SIN refresco. Al volver (o al vencerse) se restaura la de la administración.
 */
const GUARDADA = 'conversia.auth.administracion';

export interface CuentaParaVerComo {
  id: string;
  nombre: string;
  email: string;
  rol: string;
}

export function viendoComo(): boolean {
  try {
    return localStorage.getItem(GUARDADA) !== null;
  } catch {
    return false;
  }
}

export function cuentasParaVerComo(): Promise<CuentaParaVerComo[]> {
  return apiFetch('/api/auth/ver-como');
}

export async function entrarComo(userId: string): Promise<void> {
  const vista = await apiFetch<{ accessToken: string; user: User }>('/api/auth/ver-como', {
    method: 'POST',
    body: { userId },
  });
  // Se lee DESPUÉS de la llamada: si el token venció, apiFetch lo renovó y hay que guardar el nuevo.
  const { user, accessToken, refreshToken, setSession } = useAuthStore.getState();
  localStorage.setItem(GUARDADA, JSON.stringify({ user, accessToken, refreshToken }));
  setSession({ user: vista.user, accessToken: vista.accessToken, refreshToken: '' } as AuthResponse);
  // Se recarga entero: cada pantalla vuelve a pedir lo suyo con la cuenta nueva.
  window.location.assign('/');
}

/** Vuelve a la cuenta de la administración. Devuelve false si no había nada guardado. */
export function volverAMiCuenta(): boolean {
  let guardada: AuthResponse | null = null;
  try {
    guardada = JSON.parse(localStorage.getItem(GUARDADA) ?? 'null');
  } catch {
    guardada = null;
  }
  try {
    localStorage.removeItem(GUARDADA);
  } catch {
    /* sin almacenamiento: nada que limpiar */
  }
  // Guardada rota: no se queda atrapada «viendo como»; se vuelve a pedir la clave.
  if (!guardada?.accessToken || !guardada.user) {
    useAuthStore.getState().clearSession();
    window.location.assign('/login');
    return false;
  }
  useAuthStore.getState().setSession(guardada);
  window.location.assign('/');
  return true;
}
